import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import { HStack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-regular-svg-icons'
import './customDatePicker.css'
registerLocale('es', es)
const CustomInput = forwardRef(
  ({ value, onClick, placeholder: placeholderText }, ref) => (
    <HStack
      height="40px"
      padding="0px 7px"
      alignItems="center"
      justifyContent="flex-start"
      onClick={onClick}
      ref={ref}
    >
      <FontAwesomeIcon icon={faCalendar} />
      {!value && <Text variant="placeholder">{placeholderText}</Text>}
      {value && <Text variant="body1">{value}</Text>}
    </HStack>
    // <button className="example-custom-input" onClick={onClick} ref={ref}>
    //   {value}
    // </button>
  ),
)
CustomInput.displayName = 'CustomInput'
CustomInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onClick: PropTypes.func,
}
export default function CustomDatePicker({
  placeholder,
  onChange,
  maxDate,
  defaultValue,
}) {
  const [startDate, setStartDate] = useState(defaultValue || null)
  const onStartDateChange = useCallback((date) => {
    setStartDate(date)
  }, [])
  useEffect(() => {
    onChange?.(startDate)
  }, [onChange, startDate])
  return (
    <DatePicker
      selected={startDate}
      dateFormat="dd/MM/yyyy"
      isClearable
      maxDate={maxDate}
      fixedHeight
      showYearDropdown
      scrollableYearDropdown
      placeholderText={placeholder}
      onChange={onStartDateChange}
      customInput={<CustomInput />}
    />
  )
}

CustomDatePicker.propTypes = {
  defaultValue: PropTypes.objectOf(Date),
  maxDate: PropTypes.object,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
}
